import { useRef } from 'react';
import { RefArray } from './types';

/**
 * A hook used to create an array of references
 *
 * @returns an object containing an array of references and a function to set a reference value
 */
export function useRefArray<V>() {
  const ref = useRef<RefArray<V> | undefined>(undefined);

  if (ref.current === undefined) {
    const refs: (V | null)[] = [];
    const setRefs: Array<((next: V | null) => void) | undefined> = [];

    ref.current = {
      refs,
      createSetRef(this: void, index: number) {
        let setRef = setRefs[index];
        if (setRef === undefined) {
          setRef = function (next: V | null) {
            refs[index] = next;
          };
          setRefs[index] = setRef;
        }
        return setRef;
      },
    };
  }

  return ref.current;
}
